import { Linkedin, Mail } from "lucide-react";
import { FOOTER, NAV_LINKS, SITE } from "@/data/content";
import { scrollToHash } from "@/utils/scroll";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-navy-ink text-white">
    <div className="mx-auto w-full max-w-7xl px-6 py-16 md:px-12">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-display text-2xl font-bold uppercase tracking-tight">{SITE.name}</p>
          <p className="mt-2 font-serif italic text-zinc-400">{FOOTER.tagline}</p>
          <p className="mt-6 max-w-md text-xs leading-relaxed text-zinc-500">
            {FOOTER.disclosure}
          </p>
          <p className="mt-3 max-w-md text-xs leading-relaxed text-zinc-500">
            All the patents and books are now owned by Groundworks.
          </p>
          <p className="mt-3 max-w-md text-xs leading-relaxed text-zinc-500">
            This work reflects James Pratt's history prior to 1-800-Busy Dog Basement
            Technologies joining forces with Groundworks in 2025.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-semibold uppercase tracking-widest text-zinc-500">Explore</p>
          <nav className="mt-4 flex flex-col gap-3" aria-label="Footer">
            {NAV_LINKS.map((link) => (
              <a
                key={link.hash}
                href={link.hash}
                data-testid={`footer-link-${link.label.toLowerCase()}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToHash(link.hash);
                }}
                className="w-fit text-sm text-zinc-300 transition-colors hover:text-white"
              >
                {link.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs font-semibold uppercase tracking-widest text-zinc-500">Connect</p>
          <div className="mt-4 flex gap-3">
            <a
              href="https://www.linkedin.com/in/jamespratt-busydog/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="James Pratt on LinkedIn"
              title="James Pratt on LinkedIn"
              data-testid="social-linkedin"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-zinc-400 transition-colors duration-200 hover:border-white/40 hover:text-white"
            >
              <Linkedin size={16} />
            </a>
            <a
              href="https://www.crunchbase.com/person/james-pratt-41a8"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="James Pratt on Crunchbase"
              title="James Pratt on Crunchbase"
              data-testid="social-crunchbase"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-zinc-400 transition-colors duration-200 hover:border-white/40 hover:text-white"
            >
              <span className="text-[12px] font-bold lowercase leading-none tracking-tighter">cb</span>
            </a>
            <a
              href="mailto:jpratt@workdog911.com?subject=Enquiry%20via%20jamesprattbusydog.info"
              aria-label="Email James Pratt"
              title="Email James Pratt"
              data-testid="social-email"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-zinc-400 transition-colors duration-200 hover:border-white/40 hover:text-white"
            >
              <Mail size={16} />
            </a>
          </div>
          <p className="mt-4 text-xs text-zinc-500">
            Public contact details will be published here once confirmed.
          </p>
        </div>
      </div>

      <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-zinc-500 md:flex-row md:items-center md:justify-between">
        <span>© 2026 James Pratt. All rights reserved.</span>
        <span>{SITE.company}</span>
      </div>
    </div>
  </footer>
);
